import React  from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { getAuthToken, handleAuthTokenError, BASEURI } from '../utils';
import Modal from '../general/Modal';
import { FormattedMessage, FormattedDate, useIntl } from 'react-intl';
import loading from '../loading.svg';
import loadingWhite from '../loading_white.svg';
import { toZonedTime, toDate } from 'date-fns-tz';
import AppContext from '../context/AppContext';


const InvitationItem = ({ invitation, onAccept, onDecline, loadingAccept, loadingDecline }) => {
    const intl = useIntl();
    return (
        <li className="p-3 border-b border-gray-200 last:border-b-0">
            <div className="flex justify-between items-center">
                <div className="flex items-center">
                    <span className="material-icons text-blue-500 mr-3">person_add</span>
                    <span className="text-sm text-gray-700">
                        <b className="font-semibold text-gray-900">{invitation.sender}</b>
                        {" "}
                        {intl.formatMessage({ id: 'dashboardSharing.invitationText', defaultMessage: 'has invited you to the dashboard:' })}
                        {" "}
                        <b className="font-semibold text-gray-900">{invitation.tab_details?.name}</b>
                    </span>
                </div>
                <div className="flex-shrink-0 ml-4">
                    <button
                        className="k-button k-button-sm k-button-solid-primary k-rounded-md mr-2"
                        onClick={() => onAccept(invitation.id)}
                        disabled={loadingAccept}
                    >
                        {loadingAccept
                            ? <img src={loading} alt="loading" style={{ width: 20 }} />
                            : intl.formatMessage({ id: 'dashboardSharing.accept', defaultMessage: 'Accept' })}
                    </button>
                    <button
                        className="k-button k-button-sm k-button-solid k-button-solid-base k-rounded-md"
                        onClick={() => onDecline(invitation.id)}
                        disabled={loadingDecline}
                    >
                        {loadingDecline
                            ? <img src={loading} alt="loading" style={{ width: 20}} />
                            : intl.formatMessage({ id: 'dashboardSharing.decline', defaultMessage: 'Decline' })}
                    </button>
                </div>
            </div>
        </li>
    );
};


class AlertEventItem extends React.Component {

    typeIcon = {
        w: '⚠',
        c: '⚠',
        i: 'ℹ',
        p: <i style={{ color: "red" }} className="material-icons">money_off</i>
    }

    titleClass = this.props.read ? 'title' : 'title unread';

    render() {
        return <li>
            <details>
                <summary onClick={(e) => this.props.markAsRead(e, this.props)}>
                    <div className={this.titleClass}>
                        <span className={"type " + this.props.alert._type}>{this.typeIcon[this.props.alert._type]}</span>
                        <span className="name"> {this.props.alert.name} </span>
                    </div>
                    <div className="time">
                        <span className="time">
                            <FormattedDate value={toZonedTime(toDate(this.props.date), this.props.timezone)} year='numeric' month='numeric' day='numeric' hour='numeric' minute='numeric' />
                        </span>
                    </div>
                </summary>
                <div className="event-message" style={{ padding: '10px' }}>
                    <div>
                        {this.props.alert.message}
                    </div>
                    {
                        this.props.graph ?
                            <div>
                                <FormattedMessage id='app.noti.alertEventItem.chart' defaultMessage='Chart' />: {this.props.graph.chart.name}
                            </div> : ""
                    }
                    {
                        this.props.graph ?
                            <div>
                                <FormattedMessage id='app.noti.alertEventItem.graph' defaultMessage='Graph' />: {this.props.graph.label}
                            </div> : ""
                    }
                    {
                        this.props.graph ?
                            <div>
                                <FormattedMessage id='app.noti.alertEventItem.value' defaultMessage='Value' />: {this.props.value}
                            </div> : ""
                    }
                </div>
            </details>
        </li>;
    }
}


class ViewAlertEventsDialog extends React.Component {

    render() {

        return this.props.show &&
            <Dialog title={<FormattedMessage id='app.noti.notifications' defaultMessage='Notifications' />} onClose={this.props.toggle} >

                <div className='modal-wrap'>
                    <div className='modal-form-wrap'>
                        <div className='alert-modal-form-inputs-wrap'>

                            <ul className='notifications'>

                                {this.props.invitations}
                                {this.props.invitations && this.props.invitations.length > 0 && <hr className="k-hr" />}
                                {this.props.children}

                            </ul>

                        </div>
                    </div>
                </div>
                <DialogActionsBar>
                    <button className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md" onClick={this.props.toggle}>
                        <FormattedMessage id='app.noti.done' defaultMessage='Done' />
                    </button>
                    <button disabled={!this.props.prevUrl} className='k-button k-button-md k-button-solid k-button-solid-base k-rounded-md' onClick={this.props.handlePrevUrl}>
                        {
                            this.props.loadingPrevPage ?
                                <img style={{ width: '20px' }} src={loading} alt='loading' /> :
                                <FormattedMessage id='app.noti.previous' defaultMessage='Previous' />
                        }
                    </button>
                    <button disabled={!this.props.nextUrl} className='k-button k-button-md k-button-solid k-button-solid-base k-rounded-md' onClick={this.props.handleNextUrl}>
                        {
                            this.props.loadingNextPage ?
                                <img style={{ width: '20px' }} src={loading} alt='loading' /> :
                                <FormattedMessage id='app.noti.next' defaultMessage='Next' />
                        }
                    </button>
                </DialogActionsBar>
            </Dialog>;
    }

}


class ViewAlertEvents extends React.Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            loadingNextPage: false,
            loadingPrevPage: false,
            nextUrl: null,
            prevUrl: null,
            unreadCount: 0,
            events: [],
            invitations: [],
            showDialog: false,
            loadingAcceptId: null,
            loadingDeclineId: null
        }

        this.loadEvents = this.loadEvents.bind(this);
        this.loadInvitations = this.loadInvitations.bind(this);
        this.markEventAsRead = this.markEventAsRead.bind(this);
        this.toggleDialog = this.toggleDialog.bind(this);
        this.handleNextUrl = this.handleNextUrl.bind(this);
        this.handlePrevUrl = this.handlePrevUrl.bind(this);
        this.handleAcceptInvitation = this.handleAcceptInvitation.bind(this);
        this.handleDeclineInvitation = this.handleDeclineInvitation.bind(this);

    }

    componentDidMount() {

        this.loadEvents();
        this.loadInvitations();

        // this.interval = setInterval(() => {
        //     this.loadEvents();
        // }, 60000 );

    }

    componentWillUnmount() {
        // clearInterval(this.interval);
    }

    handleNextUrl() {
        if (!this.state.nextUrl)
            return

        this.setState({ loadingNextPage: true })
        this.loadEvents(this.state.nextUrl)
    }

    handlePrevUrl() {
        if (!this.state.prevUrl)
            return

        this.setState({ loadingPrevPage: true })
        this.loadEvents(this.state.prevUrl)
    }


    loadEvents(url = `${BASEURI}/api/monitor/events/`) {
        //run every 5 minutes: get new events, update unread events count and notify user

        let options = {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            }
        };

        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {
                if (!token) {
                    this.setState({
                        events: [],
                        unreadCount: 0,
                        nextUrl: null,
                        prevUrl: null,
                        loadingNextPage: false,
                        loadingPrevPage: false
                    });
                    return;
                }

                options.headers.Authorization = `Bearer  ${token}`;

                fetch(url, options)
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`Failed to load events: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then((response) => {
                        const events = Array.isArray(response?.results) ? response.results : [];
                        const unreadCount = Number.isFinite(response?.unreaded) ? response.unreaded : 0;

                        this.setState({
                            events,
                            unreadCount,
                            nextUrl: response?.next || null,
                            prevUrl: response?.previous || null,
                            loadingNextPage: false,
                            loadingPrevPage: false
                        });
                    })
                    .catch((error) => {
                        console.error('Error loading events:', error);
                        this.setState({
                            events: [],
                            unreadCount: 0,
                            nextUrl: null,
                            prevUrl: null,
                            loadingNextPage: false,
                            loadingPrevPage: false
                        });
                    });
            })
            .catch(error => console.log('Error:', error));
    }

    loadInvitations() {
        let options = {
            method: 'GET',
            headers: { "Content-Type": "application/json; charset=utf-8" }
        };

        getAuthToken()
            .then(token => token).catch(handleAuthTokenError)
            .then(token => {
                if (!token) return;
                options.headers.Authorization = `Bearer ${token}`;
                fetch(`${BASEURI}/api/dashboard/invitations/`, options)
                    .then(response => response.json())
                    .then(allInvitations => {
                        if (Array.isArray(allInvitations)) {
                            const pendingInvitations = allInvitations.filter(inv => inv.status === 'pending');
                            this.setState({ invitations: pendingInvitations });
                        }
                    })
                    .catch(error => console.error('Error fetching invitations:', error));
            });
    }

    handleAcceptInvitation(invitationId) {
        this.setState({ loadingAcceptId: invitationId });
        const options = {
            method: 'POST',
            headers: { "Content-Type": "application/json; charset=utf-8" }
        };
        getAuthToken()
            .then(token => token).catch(handleAuthTokenError)
            .then(token => {
                if (!token) {
                    this.setState({ loadingAcceptId: null });
                    return;
                }
                options.headers.Authorization = `Bearer ${token}`;
                fetch(`${BASEURI}/api/dashboard/invitations/${invitationId}/accept/`, options)
                    .then(response => {
                        this.setState({ loadingAcceptId: null });
                        if (response.ok) {
                            this.setState(prevState => ({
                                invitations: prevState.invitations.filter(inv => inv.id !== invitationId)
                            }));
                            if (this.context && typeof this.context.loadSharedTabs === 'function') {
                                this.context.loadSharedTabs();
                            }
                        } else {
                            throw new Error('Failed to accept invitation');
                        }
                    })
                    .catch(error => {
                        this.setState({ loadingAcceptId: null });
                        console.error('Error accepting invitation:', error);
                    });
            });
    }

    handleDeclineInvitation(invitationId) {
        this.setState({ loadingDeclineId: invitationId });
        const options = {
            method: 'POST',
            headers: { "Content-Type": "application/json; charset=utf-8" }
        };
        getAuthToken()
            .then(token => token).catch(handleAuthTokenError)
            .then(token => {
                if (!token) {
                    this.setState({ loadingDeclineId: null });
                    return;
                }
                options.headers.Authorization = `Bearer ${token}`;
                fetch(`${BASEURI}/api/dashboard/invitations/${invitationId}/decline/`, options)
                    .then(response => {
                        this.setState({ loadingDeclineId: null });
                        if (response.ok) {
                            this.setState(prevState => ({
                                invitations: prevState.invitations.filter(inv => inv.id !== invitationId)
                            }));
                        } else {
                            throw new Error('Failed to decline invitation');
                        }
                    })
                    .catch(error => {
                        this.setState({ loadingDeclineId: null });
                        console.error('Error declining invitation:', error);
                    });
            });
    }

    markEventAsRead(e, props) {
        //mark event as read and update unread count

        let url = `${BASEURI}/api/monitor/events/rud/${props.id}/`,
            event = { ...props };
        event.read = true;
        delete event.markAsRead;
        let options = {
            method: 'PUT',
            body: JSON.stringify(event),
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            }
        };

        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {

                options.headers.Authorization = `Bearer  ${token}`;

                fetch(url, options)
                    .then((response) => response.json())
                    .then(event => {

                        let eventList = Array.isArray(this.state.events) ? this.state.events.slice() : [];

                        let eventToReplace = null;
                        for (let i in eventList) {
                            if (eventList[i].id === event.id) {
                                eventToReplace = i;
                                break;
                            }
                        }

                        if (eventToReplace !== null)
                            eventList.splice(eventToReplace, 1, event);
                        else
                            eventList.unshift(event);

                        this.setState({ events: eventList });

                        // this.loadEvents();

                    })
            })
            .catch(error => console.log('Error:', error));

    }

    toggleDialog() {

        this.setState(state => ({ showDialog: !state.showDialog }));
    }

    componentDidUpdate() {
        // console.log(this.state);
    }

    render() {

        const eventsList = Array.isArray(this.state.events) ? this.state.events : [];
        const invitationsList = Array.isArray(this.state.invitations) ? this.state.invitations : [];

        let events = eventsList.map(event => <AlertEventItem markAsRead={this.markEventAsRead} key={event.id} {...event} />);
        let invitations = invitationsList.map(invitation => (
            <InvitationItem
                key={`inv-${invitation.id}`}
                invitation={invitation}
                onAccept={this.handleAcceptInvitation}
                onDecline={this.handleDeclineInvitation}
                loadingAccept={this.state.loadingAcceptId === invitation.id}
                loadingDecline={this.state.loadingDeclineId === invitation.id}
            />
        ));

        return (
            <div>
                {
                    this.state.unreadCount > 0 || invitationsList.length > 0 ?
                        <div
                            className="material-icons mdl-badge mdl-badge--overlap"
                            data-badge={this.state.unreadCount + invitationsList.length > 1000 ? `${parseFloat((this.state.unreadCount + invitationsList.length) / 1000).toFixed(1)}k` : this.state.unreadCount + invitationsList.length}
                            style={{ cursor: 'pointer' }}
                            onClick={this.toggleDialog}
                        >
                            notification_important
                        </div> :
                        <div
                            className="material-icons mdl-badge mdl-badge--overlap"
                            style={{ cursor: 'pointer' }}
                            onClick={this.toggleDialog}
                        >
                            notification_important
                        </div>
                }
                <Modal>
                    <ViewAlertEventsDialog
                        events={this.state.events}
                        show={this.state.showDialog}
                        toggle={this.toggleDialog}
                        nextUrl={this.state.nextUrl}
                        prevUrl={this.state.prevUrl}
                        handleNextUrl={this.handleNextUrl}
                        handlePrevUrl={this.handlePrevUrl}
                        loadingNextPage={this.state.loadingNextPage}
                        loadingPrevPage={this.state.loadingPrevPage}
                        invitations={invitations}
                    >

                        {events}

                    </ViewAlertEventsDialog>
                </Modal>
            </div>
        );

    }

}


export default ViewAlertEvents;
